import { extensionsConfig } from "client/config/extensionsConfig";
import { useDragUpload } from "client/hooks/utils/useDragUpload";
import { useEffect, useRef, useState } from "react";
import { useAddImages } from "../../ControlBar/AddImages/useAddImages";
import { useRouter } from "next/router";

export const useNoImages = () => {

    const dragUploadRef = useRef<HTMLDivElement>(null);
    const { pathname } = useRouter();
    const supportedExtensions =
        (extensionsConfig as any)[pathname?.split("/")[1] || ""] || extensionsConfig["image-compressor"];
    const [dragUploadElement, setDragUploadElement] = useState<HTMLDivElement | null>(dragUploadRef.current ?? null);
    const { handleFile, handleDeviceUploadClick } = useAddImages();
    const { isDragging } = useDragUpload(dragUploadElement, handleFile, {
        supportedExtensions: supportedExtensions,
    });

    useEffect(() => {
        dragUploadRef.current && setDragUploadElement(dragUploadRef.current);
    }, [dragUploadRef]);

    return { dragUploadRef, isDragging, handleDeviceUploadClick };
};
